function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#B8C8CC",
  fillRule: "evenodd",
  d: "M15.259 5.166c-.113-.11-.247-.166-.402-.166-.155 0-.289.055-.402.166-.113.111-.17.242-.17.394V7.8h-2c-4.243 0-6.848 1.176-7.812 3.526C4.158 12.108 4 13.08 4 14.24c0 .968.378 2.284 1.134 3.946l.094.21c.044.1.084.187.12.263.036.075.075.14.116.192.072.1.155.149.25.149.09 0 .16-.03.21-.087.05-.059.076-.132.076-.219 0-.053-.007-.13-.022-.232-.015-.102-.023-.17-.023-.206-.03-.396-.044-.755-.044-1.076 0-.589.052-1.117.156-1.583.104-.467.248-.871.433-1.212.184-.342.423-.636.714-.884.292-.248.606-.45.942-.608.336-.158.732-.282 1.188-.372.455-.09.913-.153 1.375-.188.461-.035.983-.053 1.567-.053h2v2.24c0 .152.056.283.17.394.112.11.246.166.401.166.155 0 .289-.055.402-.166l3.881-3.802c.592-.58.602-1.53.022-2.121l-.022-.022-3.881-3.803z"
});

var SvgShareOld = function SvgShareOld(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgShareOld, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/shareOld.17ce2522.svg";
export { ForwardRef as ReactComponent };